import * as Preact from "preact"

import Unit from "@fae/source/models/Unit.js"

import {Power, ShortPower} from "./Description.jsx"
import Icon from "./Icon.jsx"
import "./DiceFace.less"

export default class DiceFace {
    render() {
        if(this.props.item == undefined) return

        let elementKey = this.props.item.element
        let power = Unit.power({"stage": this.props.stage, "unit": this.props.unit, "item": this.props.item})
        let powerboosts = Unit.powerboosts({"stage": this.props.stage, "unit": this.props.unit, "item": this.props.item})

        if(power < 0.1) {
            power = 0
        }

        return (
            <div class="DiceFace" element={elementKey} power={power / 10} index={this.props.index}>
                <Icon iconKey={this.props.item.iconKey} icon={this.props.item.icon}/>
                <div class="SmallNumeral" isBoosted={powerboosts.length >= 2 && power > this.props.item.power}>
                    <ShortPower>{power}</ShortPower>
                </div>
            </div>
        )
    }
}
